import { useEffect, useState } from 'react';
import '@ffhope/lets';
import '@ffhope/lets/styles/themes.css';
import '@ffhope/lets/styles/base.css';
import Sidebar from './components/Sidebar';
import ComponentShowcase from './components/ComponentShowcase';
import './App.css';

function App() {
  const [theme, setTheme] = useState('cyan');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const themes = ['cyan', 'purple', 'pink', 'green', 'blue', 'orange'];

  return (
    <div className="app">
      <header className="header">
        <div className="header-container">
          <div className="header-left">
            <h1 className="title">@ffhope/lets</h1>
            <span className="subtitle">Web Components 组件库</span>
          </div>
          <div className="header-right">
            <select
              className="theme-select"
              value={theme}
              onChange={(e) => setTheme(e.target.value)}
            >
              {themes.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
          </div>
        </div>
      </header>
      <div className="app-layout">
        <Sidebar />
        <main className="main">
          <div className="container">
            <ComponentShowcase />
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;
